import { useParams } from "react-router-dom";
import { SharedInterfaceMonthlyReports } from "../../home/fleet/monthlyReports/sharedInterface";

export const MonthlyReportsTab = () => {
  const params = useParams();

  if (params.tab !== "monthly_reports") {
    return;
  }

  return <SharedInterfaceMonthlyReports canGenerateReports={false} />;
};
